import React, {useEffect, useState} from 'react';

import Link from 'components/navigation/Link';

export default (props) => {
	const [languageCode, setLanguageCode] = useState(null);
	const [category, setCategory] = useState(null);
	
	// HOOKS
	useEffect(() => {
		if(props.languageCode &&
			props.languageCode !== languageCode) {
			setLanguageCode(props.languageCode);
		}else if(!props.languageCode) {
			setLanguageCode('en');
		}
	}, [props.languageCode]);
	
	useEffect(() => {
		if(props.category && 
			props.category !== category) {
			setCategory(props.category);
		}
	}, [props.category]);
	
	return(
		category && languageCode &&
		<Link to={props.link}>
			<div className="category block">
				<div className="image">
					<img src={`https://aecore.app${props.objExists(category, `${languageCode}.category_image`) ? 
							category[languageCode].category_image : 
							"/assets/media/aeImageUnavailable.jpg"}`} 
							alt={props.objExists(category, `${languageCode}.category_name`) ? 
								props.capitalizeString(category[languageCode].category_name) : 
								props.site.translation && props.site.translation.categories.labels.image_unavailable} />
				</div>
				<div className="title">
					{props.objExists(category, `${languageCode}.category_name`) ? props.capitalizeString(category[languageCode].category_name, true) : ''}
				</div>
				<div className="content">
					{category.subcategory_count > 0 &&
						<div className="subtext">
							{`${category.subcategory_count} ${
								category.subcategory_count === 1 ? props.site.translation && props.site.translation.categories.labels.category : props.site.translation && props.site.translation.categories.headings.categories}`}
						</div>
					}
					{category.product_count > 0 &&
						<div className="subtext">
							{`${category.product_count} ${
								category.product_count === 1 ? props.site.translation && props.site.translation.products.labels.product : props.site.translation && props.site.translation.products.headings.products}`}
						</div>
					}
				</div>
			</div>
		</Link>
	)
}